import {Button} from "avo-ui";
import clsx from "clsx";

const InlineTabs = ({className, options, onChange, activeTab}) => {
    return (
        <div className={clsx('flex flex-row', className)}>
            <div className={'w-9 border-b'}/>
            {
                options.map((item, index) => (
                    <Button
                        key={index}
                        type={'text'}
                        title={item}
                        onClick={() => onChange(item)}
                        className={`capitalize px-10 py-2 ${activeTab === item ? 'border-x border-t border-neutral-20 font-semibold text-blue-90 rounded-b-none' : 'border-b rounded-b-none !text-[#5A5A5A]'}`}>
                    </Button>
                ))
            }
            <div className={'flex-1 border-b'}/>
        </div>
    )
}

export default InlineTabs
